import React from 'react';
import { useState, useRef, useMemo, createRef } from 'react';

const AccordionReact = ({ items }) => {
  const [clicked, setClicked] = useState(-1);
  const handleToggle = index => {
    if (clicked === index) {
      return setClicked(-1);
    }
    setClicked(index);
  };

  const refs = useRef([]);
  refs.current = items.map((item, index)=>refs.current[index] ?? createRef())

  return (
    <ul className="accordion-wrapper">
      {items.map((item, index) => {
        return (
          <li key={index} className={`accordion-item ${clicked === index ? 'active' : ''}`}>
            <button className="accordion-item-button" onClick={() => handleToggle(index)}>
              {item.title}
              <span className="accordion-item-icon">{clicked === index ? item.icon[1] : item.icon[0]}</span>
            </button>
            <div
              ref={refs.current[index]}
              className="accordion-item-description-wrapper"
              style={clicked === index ? { height: refs.current[index].current.scrollHeight } : { height: '0' }}
              onClick={()=>console.log(refs.current[index].current.scrollHeight)}
            >
              {item.description.map((paragraph, index) => {
                return (
                  <p key={index} className="accordion-item-description">
                    {paragraph}
                  </p>
                );
              })}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default AccordionReact;

//CSS Structure
/* 
.accordion-wrapper {
  .accordion-item {
    &.active {
    }
    .accordion-item-button {
      .accordion-item-icon {
      }
    }
    .according-item-description-wrapper {
      .accordion-item-description {
      }
    }
  }
}

*/
